/**
 * Strive Rights
 */
export const APPRAISE_STAFF = 'STR_AppraiseStaff';
export const APPROVE_PD_CREDITS = 'STR_ApprovePDCredits';
export const CONDUCT_WALKTHROUGHS = 'STR_ConductWalkthroughs';
export const CREATE_APPRAISAL_DOCUMENTS = 'STR_CreateAppraisalDocuments';
export const CREATE_COURSES = 'STR_CreateCourses';
export const DISTRICT_COURSE_EDITOR = 'STR_DistrictCourseEditor';
export const GUEST_ACCESS = 'GuestAccess';
export const LIMITED_COURSE_CREATOR = 'STR_LimitedCourseCreator';
export const IMPORT_PD_DATA = 'STR_ImportPDData';
export const MANAGE_APPRAISAL_SETTINGS = 'STR_ManageAppraisalSettings';
export const MANAGE_PD_SETTINGS = 'STR_ManagePDSettings';
export const MANAGE_CONFERENCES = 'STR_ManageConferences';
export const REMOVE_DOCUMENTS = 'STR_RemoveDocuments';
export const SCHOOL_COURSE_EDITOR = 'STR_SchoolCourseEditor';
export const SUBMIT_COURSE_SUGGESTIONS = 'STR_SubmitCourseSuggestions';
export const VIEW_APPRAISALS = 'STR_ViewAppraisals';
export const VIEW_APPRAISER_EVALUATION = 'STR_ViewAppraiserEvaluations';
export const VIEW_APPRAISER_GOALS = 'STR_ViewAppraiserGoals';
export const VIEW_APPRIASER_PD = 'STR_ViewAppraiserPD';
export const VIEW_GOALS = 'STR_ViewGoals';
export const VIEW_PROFESSIONAL_DEVELOPMENT = 'STR_ViewProfessionalDevelopment';
export const VIEW_WALKTHROUGHS = 'STR_ViewWalkthroughs';

/**
 * Aware Rights
 */
export const ADMINISTER_LOCAL_ASSESSMENT = 'DAT_PrintBenchmarks';
export const ANALYZE_TESTS = 'DAT_AnalyzeTests';
export const APPROVE_ITEM_BANK_QUESTIONS = 'DAT_ApproveBankQuestions';
export const CONFIGURE_SETTINGS = 'DAT_ConfigureSettings';
export const CREATE_JOURNAL_ACTIONS = 'DAT_CreateActions';
export const CREATE_LOCAL_BENCHMARKS = 'DAT_CreateBenchmarks';
export const CREATE_MONITOR_GROUPS = 'DAT_CreateMonitorGroups';
export const CREATE_STUDENT_FORMS = 'DAT_CreateForms';
export const CREATE_STUDENT_INVENTORY_TESTS = 'DAT_CreateRI';
export const EDIT_ITEM_BANK_QUESTIONS = 'DAT_ApproveBankQuestions';
export const IMPORT_TESTS = 'DAT_ImportTests';
export const MANAGE_ITEM_BANK = 'DAT_ManageBank';
export const MANAGE_CUSTOM_ITEM_BANK = 'DAT_ManageCustomItemBanks';
export const MANAGE_STUDENT_SUPPORTS = 'DAT_ManageSupports';
export const TEST_PROCTORING_ADMINISTRATION = 'DAT_TestProctoringAdministration';
export const VIEW_STUDENT_TESTS = 'DAT_ViewStudentTests';

/**
 * Custom Properties - these are not technically rights, but they are used in the rights checker to
 * show/hide nav settings with special circumstances, like Approve Pending Questions
 */
export const CAN_APPROVE_PENDING_QUESTIONS = 'canApprovePendingQuestions';
export const DELEGATE_MANAGE_BENCHMARK_TEST_BANK = 'hasDelegateManageBenchmarkTestBank';

/**
 * Beacon Rights
 */
export const CREATE_DISTRICT_ENTITIES = 'BCN_DistrictCourseCreator';
export const CURRICULUM_COURSE_ANALYZER = 'BCN_CurriculumCourseAnalyzer';

/**
 * Management Rights
 */
export const APPROVE_STUDENT_ACCESS_LISTS = 'SYS_ApproveMonitorLists';
export const CAN_MANAGE_TEACHER_TEAMS = 'SYS_ManageTeams';
export const MANAGE_CURRICULUM_DELEGATES = 'SYS_ManageCurriculumDelegates';

/**
 * Roster Rights
 */
export const VIEW_STUDENT_INFORMATION = 'RST_StudentInfo';
